(function () {
  var nav = document.getElementById('nav');
  var staticNav = nav && nav.getAttribute('data-static');

  // menu
  var burger = document.getElementById('burger');
  var menu = document.getElementById('menu');
  function setMenu(open) {
    if (!menu || !burger) return;
    menu.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger && menu) {
    burger.addEventListener('click', function () { setMenu(!menu.classList.contains('open')); });
    menu.addEventListener('click', function (e) { if (e.target.tagName === 'A') setMenu(false); });
  }

  // reveal (only below-the-fold items are staged)
  var els = [].slice.call(document.querySelectorAll('.reveal'));
  els.forEach(function (el) {
    if (el.getBoundingClientRect().top > window.innerHeight * 0.92) el.classList.add('pre');
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.remove('pre'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { if (el.classList.contains('pre')) io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.remove('pre'); });
  }

  // stitch spine
  var sp = document.getElementById('spine-path');
  var len = sp ? sp.getTotalLength() : 0;
  if (sp) { sp.style.strokeDasharray = len; sp.style.strokeDashoffset = len; }
  function updateSpine() {
    if (!sp) return;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.min(window.scrollY / h, 1) : 0;
    sp.style.strokeDashoffset = len * (1 - p);
  }

  // soft parallax on editorial panels
  var fx = [].slice.call(document.querySelectorAll('.panel .bgfx'));
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function updateParallax() {
    if (reduce) return;
    fx.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      var mid = r.top + r.height / 2 - window.innerHeight / 2;
      el.style.transform = 'translateY(' + (mid * -0.18) + 'px)';
    });
  }

  function onScroll() {
    if (nav && !staticNav) nav.classList.toggle('solid', window.scrollY > 60);
    updateSpine();
    updateParallax();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();
